import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export default function useManageRoleGroup() {
  const addGroup = async (
    organizationId: string,
    roleId: string,
    groupId: string,
    callback?: (guid: string) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexid/user-group/v1/organizations/${organizationId}/groups/${groupId}/roles/${roleId}`;
    await fetcher({
      method: 'post',
      url,
      body: {},
    })
      .then((respData) => {
        if (callback) callback(respData.id);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const removeGroup = async (
    organizationId: string,
    roleId: string,
    groupId: string,
    callback?: (guid: string) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexid/user-group/v1/organizations/${organizationId}/groups/${groupId}/roles/${roleId}`;
    await fetcher({
      method: 'delete',
      url,
      body: {},
    })
      .then(() => {
        if (callback) callback(groupId);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return {
    addGroup,
    removeGroup,
  };
}
